module.exports = __webpack_public_path__ + "img/creation_900.642afada.webp";